import { colors } from '@kmns-internal/furikake'
import CheckIcon from '@mui/icons-material/Check'
import CloseIcon from '@mui/icons-material/Close'
import HelpOutlineIcon from '@mui/icons-material/HelpOutline'
import RemoveIcon from '@mui/icons-material/Remove'
import { Stack, SvgIcon, Tooltip, Typography } from '@mui/material'
import CheckExclamation from 'src/assets/icons/check_exclamation.svg?react'

const data = [
  {
    description: '実施済み',
    icon: <CheckIcon sx={{ color: colors.text.secondary }} />,
  },
  {
    description: '期限切れで実施',
    icon: (
      <SvgIcon
        component={CheckExclamation}
        inheritViewBox
        sx={{ color: colors.warning.main }}
      />
    ),
  },
  {
    description: '未実施',
    icon: <CloseIcon sx={{ color: colors.error.main }} />,
  },
  {
    description: '予定なし',
    icon: <RemoveIcon sx={{ color: colors.text.disabled }} />,
  },
]

/**
 * 実施状況一覧画面のアイコンに関する凡例をツールチップで表示する
 */
export const StatusIconLegend = () => {
  return (
    <Tooltip
      placement="bottom-end"
      slotProps={{
        tooltip: {
          sx: {
            bgcolor: 'white',
            boxShadow: 4,
            color: colors.text.primary,
            p: 0,
          },
        },
      }}
      title={
        <Stack alignItems="flex-start" spacing={1} sx={{ p: 2 }}>
          {data.map(({ description, icon }) => (
            <Stack
              alignItems="center"
              direction="row"
              key={description}
              spacing={1}
            >
              {icon}
              <Typography variant="body2">：{description}</Typography>
            </Stack>
          ))}
        </Stack>
      }
    >
      <HelpOutlineIcon
        sx={{ color: colors.text.secondary, fontSize: '16px' }}
      />
    </Tooltip>
  )
}
